import React from "react";
import { Link } from "react-router-dom";

import EventNavigation from "../EventNavigation/EventNavigation";
import EventAbout from "../EventAbout/EventAbout";
import OurJourney from "../OurJourney/OurJourney";
import WhoItsBuiltFor from "../WhoItsBuiltFor/WhoItsBuiltFor";
import Footer from "../Footer/Footer";
import "./about_page.css";

const AboutPage = () => {
  return (
    <>
      <EventNavigation />

      <main id="about_page_main">
        <section id="about_page_intro">
          <div id="about_page_intro_inner">
            <p id="about_page_intro_eyebrow">About PropTech Club</p>
            <h1 id="about_page_intro_hdng">A curated ecosystem for the people shaping real estate.</h1>
            <p id="about_page_intro_txt">
              PropTech Club brings together developers, investors, institutions, brokers,
              technologists, and ecosystem leaders through  purposeful collaboration.
            </p>
            <div id="about_page_intro_actions">
              <Link to="/membership" id="about_page_intro_btn_primary">
                Become A Member
              </Link>
              <Link to="/gallery" id="about_page_intro_btn_secondary">
                Explore Events
              </Link>
            </div>
          </div>
        </section>

        <EventAbout />
        <OurJourney />
        <WhoItsBuiltFor />
      </main>

      <Footer />
    </>
  );
};

export default AboutPage;
